import { render, staticRenderFns } from "./SiczapInstancias.vue?vue&type=template&id=c6935cf2"
import script from "./SiczapInstancias.vue?vue&type=script&lang=js"
export * from "./SiczapInstancias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports